import React from 'react';

export const AnalyticOrders = () => (
  <h1>Analytic Orders</h1>
)
